import axios from 'axios';
import config from '@services/config';
import qs from 'qs';
import { excel } from '@services';

const http = axios.create({
	baseURL: config.apiPath + '/excel/live',
	timeout: 600e3,
	headers: {
		'Cache-Control': 'no-cache',
		Pragma: 'no-cache',
		'Content-type': 'application/x-www-form-urlencoded',
	},
	responseType: 'blob',
});

let token = '';
let expire = 0;

export const exportFileWithToken = {
	lowerResellerList(resellerId, query) {
		return this.export(`/reseller/lower/${resellerId}?${qs.stringify(query)}`);
	},
	resellWatchUserList(activityId, query) {
		return this.export(`/resell/watchUserExport/${activityId}?${qs.stringify(query)}`);
	},
	liveResellDetail(query) {
		return this.export(`/resell-detail?${qs.stringify(query)}`);
	},
	// // 订单列表导出
	// orderList(query) {
	// 	return this.export(`/license-record?${qs.stringify(query)}`);
	// },
	async getToken() {
		if (token && expire > Date.now() / 1000) {
			return token;
		}
		const { ok, data } = await excel.getToken();
		if (ok) {
			token = data.data.token;
			expire = data.data.expire;
			return data.data.token;
		}
	},
	async export(url) {
		const token = await this.getToken();
		if (!token) {
			throw 'not token';
		}
		return http
			.post(url, qs.stringify({ token }))
			.then((res) => {
				const content = res.data;
				const blob = new Blob([content]);
				const contentDisposition = qs.parse(res.headers['content-disposition']);
				console.log(contentDisposition);
				const fileName =
					contentDisposition['attachment;filename'] || contentDisposition['attachment;filename*'];
				if ('download' in document.createElement('a')) {
					// 非IE下载
					const linkEl = document.createElement('a');
					linkEl.download = fileName;
					linkEl.style.display = 'none';
					linkEl.href = URL.createObjectURL(blob);
					document.body.appendChild(linkEl);
					linkEl.click();
					URL.revokeObjectURL(linkEl.href); // 释放URL 对象
					document.body.removeChild(linkEl);
				} else {
					// IE10+下载
					navigator.msSaveBlob(blob, fileName);
				}
			})
			.catch((err) => {
				console.log(err);
			});
	},
};
